"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store';
import router from '../router';
import Qs from "qs"
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.VUE_APP_BASE_URL || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if ( !config.headers.Authorization&&window.sessionStorage.getItem('token')) {
      // config.headers.Authorization = store.state.user.token;
      config.headers.Authorization = `Bearer ${ window.sessionStorage.getItem('token')}`;

    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if(response.data.ok===false){
      const vm = new Vue()
      vm.$bvToast.toast(response.data.msg, {
        title: '错误提示',
        variant: 'danger',
      });
    }else{
      return response;
    }
  },
  function (error) {
    const vm = new Vue()
    // Do something with response error
    switch (error.response.status) {
      case 424:
      case 401:
        alert("登录已过期,请重新登录")
        router.push('/login');
        break;
      case 422:
      case 400:
        vm.$bvToast.toast(error.response.data.message, {
          title: '错误提示',
          variant: 'danger',
        });
        break;
      case 500:
        vm.$bvToast.toast('服务器错误，请稍后再试', {
          title: '错误提示',
          variant: 'danger',
        });
    }
    return Promise.reject(error);
  }
);

const _http = axios.create(config);

_http.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if ( !config.headers.Authorization&&window.sessionStorage.getItem('token')) {
      // config.headers.Authorization = store.state.user.token;
      config.headers.Authorization = `Bearer ${ window.sessionStorage.getItem('token')}`;

    }
    config.data=Qs.stringify(config.data,{indices:true})
    config.headers["Content-Type"] =config["Content-Type"]|| "application/x-www-form-urlencoded;charset=UTF-8";
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_http.interceptors.response.use(
  function (response) {
    // Do something with response data
    if(response.data.ok===false){
      const vm = new Vue()
      vm.$bvToast.toast(response.data.msg, {
        title: '错误提示',
        variant: 'danger',
      });
      throw response.data
    }else{
      return response.data;
    }
  },
  function (error) {
    
    const vm = new Vue()
    // Do something with response error
    switch (error.response.status) {
      case 424:
      case 401:
        alert("登录已过期,请重新登录")
        router.push('/login');
        break;
      case 422:
      case 400:
        vm.$bvToast.toast(error.response.data.message, {
          title: '错误提示',
          variant: 'danger',
        });
        break;
      case 500:
        vm.$bvToast.toast('服务器错误，请稍后再试', {
          title: '错误提示',
          variant: 'danger',
        });
    }
    return Promise.reject(error);
  }
);


Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
    $http: {
      get() {
        return _http;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
